export default "__VITE_ASSET__DHuC30ml__"